import { render, staticRenderFns } from "./BizCategoryEdit.vue?vue&type=template&id=6c68a88c"
import script from "./BizCategoryEdit.vue?vue&type=script&lang=js"
export * from "./BizCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports